<template>
  <div id="app" class="fixed-l h-100-l w-100">
    <div class="container flex flex-column flex-row-l w-100 h-100 pa5 pa6-l">
      <div class="left w-100 w-30-l">
        <p>Partners & Spade</p>
        <p>
          Brand
          <transition name="fade" mode="out-in">
            <span v-bind:key="currentTerm">{{ brandTerms[currentTerm] }}<span class="period" :class="{ 'vis': currentTerm === brandTerms.length - 1}">.</span></span>
          </transition>
        </p>
        <a @click.prevent="showInfo = !showInfo" href="#" class="contact-link dib mt5">Contact</a>
        <div v-if="showInfo" class="info mt5">
          <p>After working in New York for over 30 years on some of the world<span class="haas">'</span>s most innovative brands<span class="haas">,</span> I<span class="haas">'</span>m excited to bring Partners & Spade to California<span class="haas">.</span> The new move has given me the opportunity to expand our space and offer new services to meet our clients<span class="haas">'</span> ever-changing needs<span class="haas">.</span> We look forward to seeing you in our sunny new digs here out West<span class="haas">.</span></p>
          <p class="mt4">If you<span class="haas">'</span>re interested in working with us<span class="haas">,</span> or would like to view recent work<span class="haas">,</span> call<span class="haas">/</span>email us at<span class="haas">:</span></p>
          <a class="mt4 db" href="mailto:hello@partnersandspade.com">hello@partnersandspade<span class="haas">.</span>com</a>
          <a class="db" href="tel:1-510-925-2255">(510) 925-2255</a>
          <p class="mt4">Happy Trails<span class="haas">,</span></p>
          <p class="mt4">Andy Spade</p>
          <img class="w-70" :src="require(`@/assets/images/sig.png`)" alt="Any Spade signature">
          <p class="mt4">Our story continues on <a href="https://www.instagram.com/partnersandspade/" target="_blank">Instagram</a></p>
        </div>
      </div>
      <div class="right w-100 w-70-l mt5 mt0-l pl5-l">
        <img :src="require(`@/assets/images/spade.jpg`)" class="h-auto" alt="Image of Andy Spade sitting in the Partners and Spade office space.">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      showInfo: false,
      termsInterval: null,
      currentTerm: 0,
      brandTerms: [
        'Identity',
        'Incubation',
        'Experience',
        'Environments',
        'Books & Films',
        'Product Design',
        'Collaborations',
        'Culture',
        'Work Sessions',
        'Team Building',
        'Retreats',
        'Wisdom'
      ]
    }
  },
  methods: {
    startTermsInterval () {
      this.termsInterval = setInterval(() => {
        if (this.currentTerm === this.brandTerms.length - 1) {
          this.stopTermsInterval()
        } else {
          this.currentTerm++
        }
      }, 1300)
    },
    stopTermsInterval () {
      clearInterval(this.termsInterval)

      setTimeout(() => {
        this.currentTerm = 0
        this.startTermsInterval()
      }, 2500)
    }
  },
  mounted () {
    this.startTermsInterval()
  }
}
</script>

<style lang="scss">
  @import "assets/scss/index.scss";

  .info {
    p, a, span {
      font-size: 1.5rem;

      .haas {
        line-height: 0rem;
      }
    }
  }

  .period {
    font-family: 'Haas Grot Disp R 65';
    line-height: 1rem;
    opacity: 0;

    &.vis {
      opacity: 1;
    }
  }

  .right {
    img {
      max-height: 100%;
    }
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .fade-enter-to,
  .fade-leave {
    opacity: 1;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .4s;
  }
</style>
